import { EListingStatus } from "../types/listing.type";

export function normalizeStreetName(streetName: string = "") {
	return (streetName ?? "")
		.toLowerCase()
		.replace(/\s+/g, " ") // Replace multiple spaces with a single space
		.replace(/^(jalan|jl|jl\.|jln\.)/i, "jalan"); // Replace street prefix with 'jalan'
}

export function mappingColorListingStatus(status: EListingStatus) {
	switch (status) {
		case EListingStatus.PUBLISH:
			return { label: "Published", color: "success" };
		case EListingStatus.UNPUBLISH:
			return { label: "Unpublish", color: "warning" };
		case EListingStatus.CLOSED:
			return { label: "Closed", color: "error" };
		case EListingStatus.EXPIRED:
			return { label: "Expired", color: "default" };
		case EListingStatus.PENDING:
			return { label: "Pending", color: "processing" };
		case EListingStatus.WAITING_APPROVAL:
			return { label: "Waiting Approval", color: "processing" };
		case EListingStatus.REJECTED:
			return { label: "Rejected", color: "error" };
		case EListingStatus.OPEN:
			return { label: "Open", color: "default" };
		default:
			return { label: "Open", color: "default" };
	}
}
